import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  title: () => __(translations.UpdateEcoTaxPage.title, 'Update ecotax'),
  ecoTax: () => __(translations.UpdateEcoTaxPage.ecoTax, 'Ecotax'),
};
